import { Box } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';
import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';
import { UserStore } from '@gamiphy/loyalty-station-desktop/store/user';
import { useOrdersHubApi } from '@gamiphy/loyalty-station-desktop/hooks/apis';
import { AnalyticsFactory } from '@gamiphy/analytics';
import { SessionStore, SignupSteps } from '@gamiphy/loyalty-station-desktop/store/session';
import UserInfoForm from './steps/userInfoForm/UserInfoForm';
import Otp from './steps/otp/Otp';
import Success from './steps/success/Success';

const Signup: React.FC<{ onDone: () => void }> = ({ onDone }) => {
  const ordersHubApi = useOrdersHubApi();

  React.useEffect(() => {
    void (async () => {
      if (!SessionStore.coretavaSession?.unverifiedPhone) {
        if (UserStore.user?.unverifiedPhone && !SessionStore.coretavaSession?.unverifiedPhone) {
          SessionStore.updateSession({ unverifiedPhone: UserStore.user.unverifiedPhone });
        } else {
          // Try to retrieve the user info from the previous purchases on the same session (using Customer id)
          const analytics = await AnalyticsFactory.getInstance();
          const response = await ordersHubApi.genericOrdersControllerGetCustomerDetails(AppStore.app.id, analytics.customerId);

          if (response.data.phone) {
            SessionStore.updateSession({ unverifiedPhone: response.data.phone });
          }
          if (response.data.name) {
            UserStore.setUnverifiedName(response.data.name);
          }
        }
      }
    })();
  }, [ordersHubApi, UserStore.user, SessionStore.coretavaSession]);

  const content = React.useMemo(() => {
    switch (SessionStore.coretavaSession?.signupStep ?? SignupSteps.UserInfo) {
      case SignupSteps.UserInfo:
        return (
          <UserInfoForm
            defaultPhone={SessionStore.coretavaSession?.unverifiedPhone?.replace('+55', '')}
            defaultName={UserStore.unverifiedName}
            afterSubmit={({
              submittedPhone,
              name,
            }) => {
              UserStore.setUnverifiedName(name);
              SessionStore.updateSession({
                unverifiedPhone: submittedPhone,
                signupStep: SignupSteps.Otp,
              });
            }}
          />
        );
      case SignupSteps.Otp:
        return (
          SessionStore.coretavaSession?.unverifiedPhone && (
            <Otp
              phone={SessionStore.coretavaSession?.unverifiedPhone}
              name={UserStore.unverifiedName}
              onEditPhone={() => SessionStore.updateSession({ signupStep: SignupSteps.UserInfo })}
              onDone={onDone}
            />
          )
        );
      case SignupSteps.Success:
        return <Success />;
      default:
        return undefined;
    }
  }, [
    SessionStore.coretavaSession,
    UserStore.unverifiedName,
    onDone,
  ]);

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      {
        SessionStore.coretavaSession?.signupStep !== SignupSteps.Success && AppStore.app.logo && (
          <Box component="img" src={AppStore.app.logo ?? undefined} maxHeight={60} maxWidth="100%" mr="auto" />
        )
      }
      {content}
    </Box>
  );
};

export default observer(Signup);
